/*                         */
'use strict';

const log = (message, ...objects) => {
  if (
    o_global &&
    o_global.debug &&
    o_global.debug.status &&
    o_global.debug.status().activated === true
  ) {
    /*                                                      */
    /*                                  */
    console.log(message, objects);
  }
};

export default { log };
